import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  .slick-slide {
    .slice-icon-banner__list-item {
      display: inline-flex !important;
      justify-content: center;
      align-items: center;
      margin: 0;
    }
  }
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: 160%;
  margin-bottom: 50px;
  color: ${(props) => props.theme.colors.graySemi};
  ${media.largeScreen`
    margin-bottom: 30px;
  `}
  ${media.smallScreen`
    margin-bottom: 40px;
  `}
`;

export const List = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 -20px -53px;
  ${media.smallScreen`
    flex-direction: column;
    align-items: flex-start;
    margin: 0 0 -53px;
  `}
`;

export const Item = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0 20px 53px;
  ${media.mediumScreen`
    margin: 0 0 53px;
  `}
  img {
    height: 90px;
    flex-shrink: 0;
    ${media.largeScreen`
      height: 70px;
    `}
    ${media.mediumScreen`
      height: 50px;
    `}
  }
  span {
    font-family: ${(props) => props.theme.typography.thinFontFamily};
    font-size: ${(props) => props.theme.typography.h4FontSize};
    line-height: 130%;
    margin-left: 45px;
    width: auto;
    max-width: 293px;
    ${media.largeScreen`
      margin-left: 32px;
    `}
    ${media.mediumScreen`
      margin-left: 24px;
    `}
  }
`;
